import styled from 'styled-components';
import { injectSpacing } from '../../api/spacing/injectSpacing';
import { StyledTag } from '../Tag/Tag.styles';
export const StyledTagGroup = styled.div `
  --gap: var(${(props) => props.theme.responsive.spacing.xs});

  display: inline-flex;
  flex-wrap: wrap;

  width: calc(100% + var(--gap));
  margin-inline-start: calc(-1 * var(--gap));
  margin-block-start: calc(-1 * var(--gap));

  & > ${StyledTag} {
    margin-inline-start: var(--gap);
    margin-block-start: var(--gap);
  }

  ${injectSpacing('margin')}
`;
//# sourceMappingURL=TagGroup.styles.js.map